import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssetWithUsersV26 } from 'src/app/models-v26/asset-with-users-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { SwapContractInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/swap-contract-wizard/init-step/swap-contract-init-step';
import * as fromSwapContractWizardStore from './reducer';
import { State } from './state';

export const selectSwapContractWizardStoreState = createFeatureSelector<State>(
  fromSwapContractWizardStore.swapContractWizardStoreFeatureKey,
);

export const selectInitStep = createSelector(selectSwapContractWizardStoreState, (state: State): SwapContractInitStepV26 => state.initStep);

export const selectAassetTobeCancelledStepStep = createSelector(
  selectSwapContractWizardStoreState,
  (state: State): AssetWithUsersV26 => state.assetTobeCancelledStep,
);

export const selectValidationSwapAssetResponse = createSelector(
  selectSwapContractWizardStoreState,
  (state: State): ActionResponse => state.validationResponse,
);

export const selectValidationErrorMessage = createSelector(
  selectSwapContractWizardStoreState,
  (state: State): string => state.validationErrorMessage,
);

export const selectSwapAssetResponse = createSelector(
  selectSwapContractWizardStoreState,
  (state: State): ActionResponse => state.newOrderResponse,
);

export const selectErrorMessage = createSelector(selectSwapContractWizardStoreState, (state: State): string => state.errorMessage);
